import _typeof from "@babel/runtime/helpers/typeof";

var convertItemToString = function convertItemToString(item) {
  var typeOfItem = _typeof(item);

  if (typeOfItem === 'string') {
    return item;
  }

  if (['boolean', 'number', 'bigint'].includes(typeOfItem)) {
    return item.toString();
  }

  return '';
};

var getItemToString = function getItemToString(item) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (item instanceof Object) {
    var valueAccessor = options.valueAccessor;

    if (typeof valueAccessor === 'string' && item[valueAccessor] !== undefined) {
      return convertItemToString(item[valueAccessor]);
    }

    if (typeof valueAccessor === 'function' && valueAccessor(item) !== undefined) {
      return convertItemToString(valueAccessor(item));
    }
  }

  return convertItemToString(item);
};

export default getItemToString;